import { SelectedItemsContext } from './Contexts';
import { useContext } from 'react';


export default function useSelectedFigureItems(){

  const selectedFigureItems = useContext(SelectedItemsContext);

  return selectedFigureItems;

}
